import React, { useState } from 'react'

import Container from '@material-ui/core/Container'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/core/styles'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'

import Header from '../Header'
import Footer from '../Footer'
import AppContext from '../../contexts/appContext'
import styles from './Main.module.css'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: 9999,
    },
    progress: {
        color: '#fff',
    },
}))

function Main({ children }) {
    const [snackbarState, setSnackbarState] = useState(false)
    const [snackbarMsg, setSnackbarMsg] = useState('')
    const [loading, setLoading] = useState(false)

    const classes = useStyles()

    const startLoading = () => {
        setLoading(true)
    }

    const endLoading = () => {
        setLoading(false)
    }

    const showSnackbarMsg = msg => {
        setSnackbarMsg(msg)
        setSnackbarState(true)
    }
    const handleCloseSnackbar = () => {
        setSnackbarState(false)
        setSnackbarMsg('')
    }

    return (
        <AppContext.Provider
            value={{
                snackbar: { showSnackbarMsg },
                startLoading,
                endLoading,
                loading
            }}
        >
            <div className={styles.main__wrapper}>
                <Header />
                <main className={styles.main__content}>
                    <Container style={{ height: '100%' }}>{children}</Container>
                </main>
                <Footer />
            </div>
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={snackbarState}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                message={snackbarMsg}
                action={
                    <React.Fragment>
                        <IconButton
                            size="small"
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseSnackbar}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />
            {loading && (
                <Backdrop className={classes.backdrop} open={true}>
                    <CircularProgress className={classes.progress} />
                </Backdrop>
            )}
        </AppContext.Provider>
    )
}

export default Main
